import { useEffect } from 'react';

/**
 * Initializes Bootstrap tooltips for any `[data-bs-toggle="tooltip"]` element
 * present in the DOM when the calling component mounts/updates. Bootstrap
 * tooltips are not reactive to the DOM by default, so any component that
 * renders a tooltip trigger needs this (or must rely on another mounted
 * component happening to run it).
 */
export function useBootstrapTooltips(deps: React.DependencyList = []): void {
  useEffect(() => {
    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new (window as any).bootstrap.Tooltip(tooltipTriggerEl);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
